import DriveInfoCard from '../components/driveDetails/DriveInfoCard';
import OperationLog from '../components/driveDetails/OperationLog';
import DriveList from '../components/driveDetails/DriveList';
import { useLocation } from 'react-router-dom';
import { Button } from '@mantine/core';
import { Box, Container, Modal } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export default function DriveDetails() {
  const location = useLocation();
  const device = location.state?.device || {};
  //console.log(device);

  return (
    <Box display="flex" sx={{ maxWidth: 'none', justifyContent: 'center' }}>
         <Box flexGrow={1} ml={{ sm: 0 }} sx={{ maxWidth: 'none' }}>
      <div style={{ margin: '0 auto', width: '75.5vw', maxWidth: '75.5vw' }}>
        <div className="flex-col md:flex-row lg:flex-row flex  justify-between items-center mb-6">
         <h1
                  style={{
                    fontFamily: 'Nunito Sans, sans-serif',
                    fontSize: '32px',
                    fontWeight: 700,
                    color: '#202224',
                  }}
                >
            Drive Details
          </h1>
          <Button
            size="sm"
            variant="filled"
            className="export-button"
            styles={{
              root: {
                width: '150px',
                height: '36px',
                backgroundColor: '#FF7A00',
                borderRadius: '20px',
                padding: '10px 30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                border: 'none',
                cursor: 'pointer',
                boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
                '&:hover': {
                  backgroundColor: '#FF7A00',
                },
              },
              label: {
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: { xs: '12px', sm: '14px' },
                fontWeight: 500,
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              },
            }}
            onClick={(e) => {
              const button = e.currentTarget;
              const ripple = document.createElement('span');
              const diameter = Math.max(button.clientWidth, button.clientHeight);
              const radius = diameter / 2;

              ripple.style.width = ripple.style.height = `${diameter}px`;
              ripple.style.left = `${e.clientX - button.getBoundingClientRect().left - radius}px`;
              ripple.style.top = `${e.clientY - button.getBoundingClientRect().top - radius}px`;
              ripple.classList.add('export-button-ripple');

              button.appendChild(ripple);

              setTimeout(() => {
                ripple.remove();
              }, 600);

              //console.log('Exporting report...');
            }}
          >
            <FontAwesomeIcon
              icon={faDownload}
              style={{
                height: '10px',
                width: '10px',
                color: '#fff',
              }}
            />
            <span>Export Report</span>
          </Button>
        </div>

        <DriveInfoCard device={device} />

        <div className="flex flex-col gap-6 mt-6">
          {/* <OperationLog device={device} /> */}
          <DriveList device={device} />
        </div>
</div>



      <style>
        {`
          .export-button {
            position: relative;
            overflow: hidden;
          }
          .export-button-ripple {
            position: absolute;
            border-radius: 50%;
            background-color: rgba(255, 255, 255, 0.4);
            transform: scale(0);
            animation: ripple 0.6s linear;
            pointer-events: none;
          }
          @keyframes ripple {
            to {
              transform: scale(4);
              opacity: 0;
            }
          }
        `}
      </style>
    </Box>
    </Box>
  );
}